import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import OfferPagination from './OfferPagination';
import {
  allOffersQuery,
  investorOffersQuery,
  allUserInvestments,
} from '../../apollo';

const DashboardRoutes = () => (
  <Switch>
    <Route
      exact
      path='/dashboard/all-offers'
      component={(props) => (
        <OfferPagination query={allOffersQuery} {...props} />
      )}
    />
    <Route
      exact
      path='/dashboard/my-offers'
      component={(props) => (
        <OfferPagination query={investorOffersQuery} {...props} />
      )}
    />
    <Route
      exact
      path='/dashboard/my-investments'
      component={(props) => (
        <OfferPagination query={allUserInvestments} {...props} />
      )}
    />
    <Route component={() => <Redirect to='/dashboard/all-offers' />} />
  </Switch>
);

export default DashboardRoutes;



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardRoutes.js